import { createSlice } from '@reduxjs/toolkit';

export const pubusersSlice = createSlice({
  name: 'pubusers',
  initialState: {
    value: []
  },
  reducers: {
    setPubUsers: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const { setPubUsers } = pubusersSlice.actions;
export default pubusersSlice.reducer;
